import { Component } from '@angular/core';
import { DatePipe, Location } from '@angular/common';
import {SettingsService} from 'src/app/services/settings.service'
import { Router ,ActivatedRoute} from '@angular/router';
import { PageEvent } from '@angular/material/paginator';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators,FormControl } from '@angular/forms'
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import { Subscription } from 'rxjs';
import {ReportingConfigService} from 'src/app/services/reporting-config.service'
import { City, Country, State, StaticdataService } from 'src/app/services/staticdata.service';
import { DataService } from 'src/app/services/data.service';
import { FlightService } from 'src/app/services/flight.service';
import {CarrierCodeService} from '../../services/carrier-code.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-cart-status',
  templateUrl: './cart-status.component.html',
  styleUrls: ['./cart-status.component.css']
})
export class CartStatusComponent {

  // showCartInformation:boolean=false
  // showItinerary:boolean=false
  // showClientInformation:boolean=false
  
  numbers: number[] = Array.from({ length: 25 }, (_, i) => i + 1);
  // Default:any
  //
  // showDataEntity:boolean=false;
  // search:any={searchText:""}
  // showDataEntityPopup:boolean=false
  // DataEntityRegFg!:FormGroup
  // columnsDataEntityDisplay: string[] = ['expand','Name','isEnabled'];
  // expandedElement!: any | null;
  // totalElements:any=0
  // action:any
  // entityList:any;
  // DataEntity:any=[]
  // creationDate:any
  // id:any
  thirdFlights:any
  fourthFlights:any
  thirdLastFlight:any
  fourthLastFlight:any
  airData:any
  flightList:any
  carrierCode:any=[]
  flights:any
returnFlights:any
returnLastFlight:any
lastflight:any
clientName:any

  constructor(private SettingsService:SettingsService,private CarrierCodeService:CarrierCodeService,private router:Router,private location:Location,private fb : FormBuilder, private  toastMsgService : ToastmsgService,
    private DataEntityService:ReportingConfigService,private FlightService:FlightService,
    private StaticdataService:StaticdataService,private route:ActivatedRoute,private DataService:DataService,private UserService:UserService){
      this.carrierCode=this.CarrierCodeService.carrierCode()

      this.DataService.portMessage.subscribe((message:any) => {
        this.airData = message
        // this.getUserByUUid(this.airData?.corporate)
        this.dataEntitylist(this.airData?.corporate.split('-')[0])
      })

      if(this.airData && this.airData.airItineraries.length!=0){
        
         
      

console.log( this.airData)      
this.getFlightList();

      const returnItem=this.airData?.airItineraries[1];
      const thirdItem=this.airData?.airItineraries[2];
      const fourthItem=this.airData?.airItineraries[3];

     if (returnItem) {
        // Object is not empty
       // console.log(returnItem)
        this.returnFlights=returnItem
        const returnLastFlight=this.returnFlights?.flightDetails?.flightDetailsList[this.returnFlights?.flightDetails?.flightDetailsList.length - 1];
        this.returnLastFlight=returnLastFlight
       // console.log('Data is not an empty object');
        
      }
      if (thirdItem) {
        // Object is not empty
       // console.log(returnItem)
        this.thirdFlights=thirdItem
        const thirdLastFlight=this.thirdFlights?.flightDetails?.flightDetailsList[this.thirdFlights?.flightDetails?.flightDetailsList.length - 1];

        this.thirdLastFlight=thirdLastFlight
       // console.log('Data is not an empty object');
      
      }
      if (fourthItem) {
        // Object is not empty
       // console.log(returnItem)
        this.fourthFlights=fourthItem
        const fourthLastFlight=this.fourthFlights?.flightDetails?.flightDetailsList[this.fourthFlights?.flightDetails?.flightDetailsList.length - 1];

        this.fourthLastFlight=fourthLastFlight
       // console.log('Data is not an empty object');
      
      }
      
      const item = this.airData?.airItineraries[0];
    //console.log(item)
    
    this.flights=item
    
       console.log(this.flights?.flightDetails?.flightDetailsList[0].schDepartureTime)
      //this.SettingsService.decodeTransformedEmail(data.flightDetails)
      const lastFlight = this.flights?.flightDetails?.flightDetailsList[this.flights?.flightDetails?.flightDetailsList.length - 1];
       
    //console.log(lastFlight)
    this.lastflight = lastFlight
    }
    }
   

    nextPage(event:PageEvent) {
    
      let page:any = {};
      page['page'] = event.pageIndex.toString();
      page['size'] = event.pageSize.toString();
      
      //this.getAllUser(page)
    
    }
  dataFields(){
    // this.DataEntityRegFg=this.fb.group({
    //     "address":[''],
    //     "phone":[''],
    //     "email":['',[Validators.email]],
    //     "state":[''],
    //     "gstType":[''],
    //     "gstName":[''],
    //     "entityGST":[''],
    //     "gstAccountCode":[''],
    //     "entityName":['',[Validators.required]],
    //     "accountCode":['',[Validators.required]],
    //     "isEnabled":['']
        
    // });
    
  }
  closePopup() {
    // this.showDataEntityPopup=false
    
    this.dataFields()
  }
  AddDataEntity(){
    

    //   this.DataEntityService.saveEntity(this.DataEntityRegFg.value,this.id)
    //   .subscribe({
    //     next : (res) => {
    //       if(res.status==200 || res.status==201) {
    //         this.toastMsgService.setMsg({msg : "Billing Entity Added Successfully!",msgTitle : "Success", msgType : "I"});
           
    //        this.showDataEntityPopup=false
    //        this.dataFields();
    //        this.dataEntitylist()

    //       } else {
    //         const body : any = res.body;
    //         this.registerDataEntityErrorMsg(res.status,body?.result);
    //       } 
  
    //     },error : (err) => {
  
    //       this.registerDataEntityErrorMsg(err.status,err.error);
    //     }
    //   }
    // )
  }
  
  registerDataEntityErrorMsg(status : number,msg : string) {
    if(status >=500) {
      this.toastMsgService.setMsg({msg : "Failed to save Billing Entity",msgTitle : "Warning", msgType : "W"});
    } else {
  
      this.toastMsgService.setMsg({msg : "Failed to save Billing Entity",msgTitle:  "Warning", msgType : "W"});
    } 
  }
  
  dataEntitylists(){

  //    this.DataEntityService
  //   .listEntities(this.id)
  //   .subscribe({
  //      next : (res:any) => {
  //        if(res) {
  //       let data=res
  //       this.DataEntity=data
       
  //        } else {
        
  //        } 
  //      },error : (err) => {

  //    }
  //    }
  //  )
  }
  backClick(){
    window.location.href = "/app/manage-carts"
    }
      rowdataEntityClick(element:any){
       
        // this.action="updateEntity"
        // this.showDataEntityPopup=true
        // this.DataEntityRegFg=this.fb.group({
        //   "address":[element?.address],
        //   "phone":[element?.phone],
        //   "email":[element?.email,[Validators.email]],
        //   "state":[element?.state],
        //   "gstType":[element?.gstType],
        //   "gstName":[element?.gstName],
        //   "entityGST":[element?.entityGST],
        //   "gstAccountCode":[element?.gstAccountCode],
        //   "entityName":[element?.entityName,[Validators.required]],
        //   "accountCode":[element?.accountCode,[Validators.required]],
        //   "isEnabled":[element?.isEnabled.toString()],
        //   "entityId":[element?.entityId]
        // });
       
      }
      formatDate(val: Date) {
        let convertedValue:any = ""
        if(val){
        let datepipe = new DatePipe("en");
        //return datepipe.transform(val, "dd-MM-yyyy hh:mm:ss");
        convertedValue =  datepipe.transform(val, "dd-MM-yyyy hh:mm:ssa");
        }
        return convertedValue;
      }
     
     
     
      stateData:any
stateList(){
  this.StaticdataService
  .getStates()
  .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res
     this.stateData=data
     console.log(this.stateData)
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}

getFlightList(){
   
  this.FlightService
  .getFlightList()
  .subscribe({
    next : (res:any) => {
      if(res) {
       let data:any
       data=res  
       this.flightList=data
   
      } else {    
      } 
    },error : (err) => {

      
    }
  }
)
}
converter(item:any){
  const totalMinutes = item ;
  const hours = Math.floor(totalMinutes / 60);
  const remainingMinutes = totalMinutes % 60;
  item=`${hours}h ${remainingMinutes}m`
  return item
}
fligthNameFilter(item:any){
if(item){
let flightName:any=[]
flightName=this.carrierCode.filter((itm: { carrierCode: any; })=>itm.carrierCode === item)
if(flightName.length===0){
 return item

}else{
 flightName =flightName[0].flightName
 return flightName
}}else{
return item
}
}
cityFilter(item:any){
  

  if(item && this.flightList){
   

    item=this.flightList.filter((itm: { iataCode: any; })=>itm.iataCode === item)

  item=item[0]?.city

return item}else{
  return item
}
}
airPortFilter(item:any){
  
  if(item && this.flightList){
  item=this.flightList.filter((itm: { iataCode: any; })=>itm.iataCode === item)

item=item[0]?.name
return item}else{
  return item
}
}
timeFormate(date:any){
  date=this.convertToISOStringFormat(date)
  const parsedDate = new Date(date);
  const datePipe = new DatePipe('en-IN');
  date = datePipe.transform(parsedDate, 'hh:mma');
  // date = datePipe.transform(parsedDate, 'EEE dd MMM yyyy');

return date

}
convertToISOStringFormat(dateString:any) {
  // Remove the ' 00:00' part and then add 'Z' at the end
  const isoDateString = dateString.replace('00.000 00:00', '00.000Z');
  return isoDateString;
}
flightlogoFilter(item:any){
  
  if(item){
     let flightName:any=[]
  flightName=this.carrierCode.filter((itm: { carrierCode: any; })=>itm.carrierCode === item)
  
  if(flightName.length===0){
   return item
 
 }else{
   flightName =flightName[0]?.logo
   return flightName
 }
  }else{return item}
 }
 dateFormate(date:any){

  date=this.convertToISOStringFormat(date)
  const parsedDate = new Date(date);
  const datePipe = new DatePipe('en-IN');
  date = datePipe.transform(parsedDate, 'EEE dd MMM yyyy');
  // date = datePipe.transform(parsedDate, 'EEE dd MMM yyyy');
return date

}
scroll(el: HTMLElement) {
  el.scrollIntoView();
}


getUserByUUid(id:any){
 
  this.UserService.getUserbyUUid(id)
  .subscribe({
    next : (res:any) => {
      if(res) {
     this.clientName= res?.name

      } else {
      } 
    },error : (err) => {

    }
  }
)


}
passengerDetails(item:any){
  console.log(item)
return item.filter((passenger:any)=>passenger.passengerType==='ADT')
}

displayJSON(json:any) {
  let result:any={ ...json }
  delete result.otherData;
delete result.corporateFare;
delete result.fareDetailsPerPassengerType.miscellaneousData;
delete result.fareDetailsPerPassengerType.commercialData;
delete result.seatsAvailability;
delete result.passengerType;
delete result.baggageInfo;


//   if ("commercialData" in json && "miscellaneousData" in json && "seatsAvailability" in json && "passengerType" in json && "corporateFare" in json && "baggageInfo" in json && "otherData" in json  ) { 
//      // let container:any = document.getElementById('json-container');
//  }else{

//  }


 return JSON.stringify(result, null, 4)
 ;
}


DataEntity:any=[]
  billingEntity:any
  dataEntitylist(id:any){
    this.DataEntityService
   .listEntities(id)
   .subscribe({
      next : (res:any) => {
        if(res) {
       let data=res
       this.DataEntity=data
       let entity:any=[]
       if(this.airData?.billingEntity){
       entity=this.DataEntity.filter((item:any)=>item.entityRefId===this.airData?.billingEntity)
       this.billingEntity=entity[0]?.entityName
      }
        } else {
       
        } 
      },error : (err) => {

    }
    }
  )
 }

 displayWEJSON(result: any): string {
  // Helper function to replace null with undefined
  const replaceNullWithUndefined = (obj: any): any => {
    if (obj === null) {
      return undefined;
    }
    if (Array.isArray(obj)) {
      return obj.map(replaceNullWithUndefined);
    }
    if (typeof obj === 'object' && obj !== null) {
      return Object.fromEntries(
        Object.entries(obj).map(([key, value]) => [key, replaceNullWithUndefined(value)])
      );
    }
    return obj;
  };

  // Replace null with undefined in the result object
  const modifiedResult = replaceNullWithUndefined(result);

  // Convert the modified result to a JSON string with 4-space indentation
  return JSON.stringify(modifiedResult, (key, value) => value === undefined ? undefined : value, 4);
}
}
